module.exports = __webpack_public_path__ + "img/openclipart.png";